/**
 * Adds formatting of devices into proper array of objects.
 * @param {array} data - The array of devices to be formatted.
 * @return {array} The formatted array in reverse, in order to render them in descending order.
 */
export default function getDevices (data) {
  let newData = []

  for (let i = 0; i < data.length; i++) {
    newData.push({
      device: {
        device_name: data[i].device_name,
        company_name: data[i].company_name
      },
      device_id: data[i].device_id,
      address: {
        city: data[i].city,
        street_address: data[i].street_address,
        province: data[i].province,
        postal_code: data[i].postal_code
      },
      usage: { times_used: data[i].times_used },
      activity: data[i].last_used
    })
  }

  return newData.reverse()
}
